const FontSize = {
    xxs: 0.625, // 11px
    xs: 0.75, // 12px
    s: 0.81, // 13px
    sm: 0.875, // 14px
    m: 1, // 16px
    md: 1.125, // 18px
    l: 1.5, // 24px
    xl: 1.75, // 28px
    xxl: 2.25, // 36
    xxxl: 3, //48px
};

export type FontSizeType = keyof typeof FontSize;

export default FontSize;
